import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { titleForTab } from "../navigation-shell.js";
import type { Tab } from "../app-view-state.js";

@customElement("dashboard-header")
export class DashboardHeader extends LitElement {
  override createRenderRoot() {
    return this;
  }

  /** Current page for breadcrumb subtitle */
  @property() tab: Tab = "projects";
  /** Sidebar / topbar product name */
  @property({ type: String }) brandLabel = "EAD Explore";
  /** Tab dispatched when clicking the breadcrumb root */
  @property({ type: String }) homeTab: Tab = "projects";
  /** Optional context label appended to the breadcrumb, e.g. selected run name. */
  @property({ type: String }) contextLabel = "";

  override render() {
    const label = titleForTab(this.tab);

    return html`
      <div class="dashboard-header">
        <div class="dashboard-header__breadcrumb">
          <span
            class="dashboard-header__breadcrumb-link"
            @click=${() =>
              this.dispatchEvent(
                new CustomEvent("navigate", {
                  detail: this.homeTab,
                  bubbles: true,
                  composed: true,
                }),
              )}
          >
            ${this.brandLabel}
          </span>
          <span class="dashboard-header__breadcrumb-sep">›</span>
          <span class="dashboard-header__breadcrumb-current">${label}</span>
          ${this.contextLabel.trim()
            ? html`
                <span class="dashboard-header__breadcrumb-sep">›</span>
                <span class="dashboard-header__breadcrumb-current">${this.contextLabel.trim()}</span>
              `
            : ""}
        </div>
        <div class="dashboard-header__actions">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
